/**
 * Calculate combined savings when subscription + sale discounts stack.
 * @param {number} subscriptionPercent - Subscription discount as percentage (e.g., 15 for 15%)
 * @returns {number} Combined savings percentage
 */
function getCombinedSavingsPercent(subscriptionPercent) {
  const discountSettings = window.discountSettings;
  const productSettings = window.productSettings;
  const subscriptionDiscount = subscriptionPercent / 100;

  if (productSettings?.inSaleCollection &&
      discountSettings?.salePriceEnabled &&
      (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) {
    const saleDiscount = discountSettings?.saleDiscount / 100;
    return (1 - ((1 - subscriptionDiscount) * (1 - saleDiscount))) * 100;
  }

  return subscriptionPercent;
}

/**
 * Inserts the Liquid-rendered window.benefitsText HTML
 * into every PDP's subscription radio label.
 */
function injectSubscriptionBenefits() {
  if (typeof window.benefitsText !== 'string') return;
  const radioLabel = document.querySelector('.subscription-radio .rc-radio__label');
  if (!radioLabel) return;

  // remove any previously injected container
  const existing = radioLabel.parentElement.querySelector('.subscription-widget-benefits');
  if (existing) existing.remove();

  radioLabel.insertAdjacentHTML('afterend', window.benefitsText);
}

// 1) Always inject on page load
document.addEventListener('DOMContentLoaded', injectSubscriptionBenefits);

// 2) Also re-inject as soon as the Recharge widget renders
const benefitsInterval = setInterval(() => {
  // look for the radio label
  if (document.querySelector('.subscription-radio .rc-radio__label')) {
    injectSubscriptionBenefits();
    clearInterval(benefitsInterval);
  }
}, 500);

jQuery(window).bind("pageshow", function (event) {
  //fix safari bug backward/forwards cache  needed for page transitions
  if (event.originalEvent.persisted) {
    window.location.reload();
  }
});

if (jQuery('.countdown').length) {

  $(function() {
    countDown.init();
    updateCountdowns();
    let countdownIntervalId = setInterval(updateCountdowns, 1000);
    jQuery('.countdown-container').addClass('on');

    // Pause countdown when tab is hidden to save resources
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearInterval(countdownIntervalId);
      } else {
        countdownIntervalId = setInterval(updateCountdowns, 1000);
      }
    });

    function updateCountdowns() {
      countDown.validElements.forEach((element, i) => {
        countDown.changeTime(element, countDown.endDate[i], i);
      });
    }
  });
  
  const countDown = {
    endDate: [],
    validElements: [],
    display: [],
    initialHeight: undefined,
    initialInnerDivMarginTop: undefined,
    originalBorderTopStyle: undefined,
  
    init: function() {
      $('.countDown').each(function() {
        const regex_match = $(this).text().match(/([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/);
        if (!regex_match) return;
  
        const end = new Date(regex_match[3], regex_match[2] - 1, regex_match[1], regex_match[4], regex_match[5], regex_match[6]);
  
        if (end > new Date()) {
          countDown.validElements.push($(this));
          countDown.endDate.push(end);
          countDown.changeTime($(this), end, countDown.validElements.length - 1);
          $(this).html(countDown.display.next.map(item => `<div class='container'><div class='a'><div>${item}</div></div></div>`).join(''));
        } else {
          $(this).html("<p class='end'>Sale has ended.</p>");
        }
      });
    },
  
    reset: function(element) {
      // This function appears to be incomplete, as it currently doesn't do anything.
    },
  
    changeTime: function(element, endTime) {
      if (!endTime) return;
  
      const today = new Date();
      if (today.getTime() <= endTime.getTime()) {
        countDown.display = {
          'last': this.calcTime(endTime.getTime() - today.getTime() + 1000),
          'next': this.calcTime(endTime.getTime() - today.getTime())
        };
        countDown.display.next = countDown.display.next.map(item => item.toString().padStart(2, '0'));
        countDown.display.last = countDown.display.last.map(item => item.toString().padStart(2, ''));
  
        element.find('div.container div.a div').each((index, div) => {
          $(div).text(countDown.display.last[index]);
        });
  
        this.reset(element.find('div.container'));
      } else {
        element.html("<p class='end'>Sale ended</p>");
      }
    },
  
    calcTime: function(milliseconds) {
      const secondsTotal = Math.floor(milliseconds / 1000);
      const days = Math.floor(secondsTotal / 86400);
      const hours = Math.floor((secondsTotal % 86400) / 3600);
      const minutes = Math.floor((secondsTotal % 3600) / 60);
      const seconds = secondsTotal % 60;
      return [days, hours, minutes, seconds];
    }
  }
  
}


document.addEventListener('DOMContentLoaded', function () {
  const carousel = document.querySelector('.before-and-after-slideshow-v4 #beforeAfter .carousel');
  const isLargeScreen = window.matchMedia('(min-width: 990px)').matches;
  const isHomePage = document.body.classList.contains('template-index');

  if (carousel) {
    const options = {
      setGallerySize: true,
      autoPlay: true,
      draggable: true,
      groupCells: 1,
      contain: true,
      pageDots: true,
      imagesLoaded: true,
      lazyLoad: true,
      prevNextButtons: false,
      adaptiveHeight: false,
      wrapAround: true,
      accessibility: false,
      arrowShape: 'M 10,50 L 45,85 L 50,80 L 20,50  L 50,20 L 45,15 Z',
    };

     if (!isLargeScreen) {
       options.autoPlay = false;
     }
    
    // Override options if NOT home page AND screen is wide
    if (isLargeScreen && !isHomePage) {
      options.prevNextButtons = false;
      options.pageDots = false;
      options.draggable = false;
      options.autoPlay = false;
    }

    const flkty = new Flickity(carousel, options);

    // Dynamically set cell heights
    const setCellHeights = () => {
      const viewportHeight = carousel.querySelector('.flickity-viewport').offsetHeight;
      const cells = carousel.querySelectorAll('.carousel-cell');
      cells.forEach((cell) => {
        cell.style.height = `${viewportHeight}px`;
      });
    };

    // Set heights after Flickity is ready
    flkty.on('ready', setCellHeights);

    // Update heights on resize
    flkty.on('resize', setCellHeights);
  }
});

if (jQuery("#how-it-works").length) {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  gsap.to("#how-it-works-subnav", {
    scrollTrigger: {
      trigger: "#how-it-works-right",
      markers: false,
      start: "top 99px",
      //endTrigger:"html",
      end: "bottom bottom",
      pin: "#how-it-works-subnav-container",
      scrub: 1,
    },
    y: 0,
  });

  let links = gsap.utils.toArray("#how-it-works-subnav a");
  links.forEach((a) => {
    let element = document.querySelector(a.getAttribute("href")),
      linkST = ScrollTrigger.create({
        trigger: element,
        start: "top top",
        markers: false,
      }),
      highlightST = ScrollTrigger.create({
        trigger: element,
        start: "top center",
        end: "bottom center",
        onToggle: (self) => self.isActive && setActive(a),
      });
    a.addEventListener("click", function (e) {
      e.preventDefault();
      /* get sectionID and strip to just get the integer
        if current ID is < target ID, no offset
        else (if current ID is > target ID) set offset to header height, 
        then deduct that offset from the scrollto position */
      gsap.to(window, {
        duration: 1,
        scrollTo: linkST.start - 90,
        overwrite: "auto",
      });
    });
  });

  function setActive(link) {
    links.forEach((el) => el.classList.remove("active"));
    //link.classList.add("active");
  }
}
/* end if how-it-works */

$(".mega-menu").each(function () {
  let megaMenu = $(this);
  let details = megaMenu.find(".mega-menu__details");
  let menuItems = megaMenu.find(".mega-menu__child");

  // Show first details item by default
  details.hide().first().show();
  menuItems.first().addClass('hover-active');

  function activateItem(item) {
    menuItems.removeClass('hover-active');
    item.addClass('hover-active');
    details.hide().eq(item.index()).show();
  }

  menuItems.hover(
    function () {
      activateItem($(this));
    },
    function () {
      if (!megaMenu.find(".mega-menu__details:hover").length) {
        $(this).removeClass('hover-active');
        menuItems.first().addClass('hover-active');
        details.hide().first().show();
      }
    }
  );

  // Keyboard parity with the hover switch: focusing a category shows its
  // panel, and ArrowDown/ArrowRight moves into that panel's first link.
  // The arrow hop is required — hidden panels aren't tabbable, so Tab on
  // its own can only ever land in the last category's panel.
  menuItems.on('focusin', function () {
    activateItem($(this));
  });
  menuItems.on('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowRight') return;
    let first = details.eq($(this).index()).find('a[href], button').first();
    if (first.length) {
      e.preventDefault();
      first.focus();
    }
  });
});

$('body').on('click', '.menu-drawer__top-menu > li', function(e) {
  $(this).siblings().removeClass('active');
  $(this).addClass('active');
  $('.menu-drawer__menus > ul').hide();
  $('.menu-drawer__menus > ul').eq($(this).index()).show();
  // ADA 4.1.2: keep the tab buttons' expanded state in sync (see header-drawer.liquid)
  $(this).siblings().find('button[aria-expanded]').attr('aria-expanded', 'false');
  $(this).find('button[aria-expanded]').attr('aria-expanded', 'true');
});

if (jQuery("#subnav-bar").length) {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
  ScrollTrigger.create({
    trigger: "#subnav-bar",
    start: "top " + `+=${$("#shopify-section-header").innerHeight()}`,
    end: "max",
    pin: ".subnav-pin-trigger",
    pinSpacing: false,
    markers: false,
    invalidateOnRefresh: true,
    toggleClass: { targets: ".moving-subnav", className: "active" },
  });
}

$(function ($) {
  if (jQuery(".videoWrapper").length) {
    $('.video').parent().click(function () {
      $this = $(this);
      if ($(this).children(".video").get(0).paused) {
        $(this).children(".video").get(0).play();
        $(this).children(".video").attr('controls', true);
        $(this).children(".playpause, .videooverlay").fadeOut('fast', function () {
          $this.children(".playpause, .videooverlay").remove();
        });
      }
    });
  }

  if (jQuery('#insta-feed').length) {
    jQuery('#insta-feed').on('click', function() {
      window.open("https://www.instagram.com/areygrey");
    })
  }

  /* recover password link */
  if (jQuery("#recoverLink").length) {
    $("#recoverLink").on("click", function () {
      $("#recover, #recover+div").css("display", "block");
    });
  }
  $(document).on("click", 'a[href^="#"]', function (e) {
    e.preventDefault();
    if (jQuery("#subnav-bar").length) {
      $offsetTop =
        jQuery("#shopify-section-header").outerHeight() +
        jQuery("#subnav-bar").outerHeight() +
        39;
    } else {
      $offsetTop = jQuery("#shopify-section-header").outerHeight();
    }
/*
    jQuery("html, body").animate(
      {
        scrollTop:
          jQuery('[id="' + jQuery.attr(this, "href").substr(1) + '"]').offset()
            .top - $offsetTop,
      },
      200
    );
    */
    
    const targetId = $(this).attr("href");
    const $target = $(targetId);

    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top - $offsetTop
      }, 600, function () {
        // Sequential focus must follow the scroll (WCAG 2.4.3) — the
        // skip-to-content link only "skips" if the target takes focus.
        const target = $target.get(0);
        if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
        target.focus({ preventScroll: true });
      });
    }

    return false;
  });

  jQuery(
    // [data-group-tab] = Shop All group-switch pills: collection-group-toggle.liquid
    // toggles them client-side (replaceState, no reload) — the fade-out +
    // window.location navigation here would force a full reload on top of it.
    'a:not(.external):not([target="_blank"]):not(.js-okeReviews-mediaStrip-item):not([data-group-tab])'
  ).on("click", function (e) {
    if (jQuery(this).hasClass("external")) {
      return true;
    }
    if (jQuery(this).data("href")) {
      $href = jQuery(this).data("href");
    } else {
      $href = jQuery(this).attr("href");
    }
    // Same-page hash links never reload, so the fade-out below would leave
    // #MainContent stuck at opacity 0 (blank page after the skip link).
    // The delegated a[href^="#"] handler above owns in-page scrolling.
    if ($href && $href.charAt(0) === "#") {
      return true;
    }
    e.preventDefault();

    if ($href != "#") {
      jQuery("#loader").fadeIn();
      jQuery("header.site-header").addClass("dark");
      jQuery("#MainContent, .header__submenu").animate(
        { opacity: "0", "margin-top": "0%" },
        function () {
          window.location.href = $href;
        }
      );
    }
  });

  /* product detail page  tabs OLD*/
  jQuery("ul.tabs").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });
    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });

  /* new: */
  jQuery("ul.tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");

    jQuery("ul.tabs li").removeClass("current");
    jQuery(".tab-content").removeClass("current");

    jQuery(this).addClass("current");
    jQuery("#" + tab_id).addClass("current");
  });
});

jQuery(window).on("load", function () {
  jQuery("#mainContent").animate({ opacity: "1" }, function () {
    if (window.location.hash) {
      jQuery("html, body").animate({
        scrollTop: jQuery(window.location.hash).offset().top - 20,
      });
    }
  });
});

// Subscription Widget 1.0 Customization:  New version using MutationObserver

//const benefitsText = `<div class="subscription-widget-benefits">
 // <ul class="subscription-widget-benefits-list">
//    <li>Free US Shipping</li>
 //   <li>Free Gifts</li>
 //   <li>Edit, pause, or cancel anytime</li>
 // </ul>
//</div>`;

//old-price is not updated when loading PDP with non-default variant pre-selected 

let cachedPrice = null;

const formatPrice = (price) => {
  const priceNumber = parseFloat(price);

  return priceNumber % 1 === 0 
  ? priceNumber.toFixed(0)
  : priceNumber.toFixed(2)
}

const updateOldRechargeWidget = () => {
  try {
    const widgetElement = document.querySelector('.rc-widget');
    const productSettings = window.productSettings;
    const discountSettings = window.discountSettings;
    const stickyAtcSale = document.querySelector('#sticky-atc-subscribe');
    const stickyAtcOneTime = document.querySelector('#sticky-atc-onetime');

    if (!widgetElement) return;

    const subscriptionTextElement = document.querySelector('.rc-radio__subscription');
    const priceElement = document.querySelector('.rc-radio__price');
    const oneTimePriceElement = document.querySelector('.onetime-radio .rc-radio__label');
    const atcButton = document.querySelector('.product-form__submit');

    if (!subscriptionTextElement || !priceElement || !oneTimePriceElement || !atcButton) {
      return;
    }

    const subscriptionText = subscriptionTextElement.textContent;
    if (cachedPrice === null) {
      const price = priceElement.textContent.trim().split(' ')[0];
      cachedPrice = price;
    }

    const baseDiscount = parseFloat(subscriptionText.split('+')[1].replace('Save', '').replace('%', '').trim());
    const totalSavings = getCombinedSavingsPercent(baseDiscount);

    subscriptionTextElement.innerHTML = `Subscribe <span class="plus">+</span> <span class="save-percentage">Save ${totalSavings.toFixed(0)}%</span>`;
    const stickyAtcSavePercentage = document.querySelector('.sticky-add-to-cart .auto-replenish-save-text');
    stickyAtcSavePercentage.innerHTML = `SAVE ${totalSavings.toFixed(0)}%`;

    const currentPrice = cachedPrice.replace('$', '').replace(/\.00$/, '');
    const savingsPercentage = parseFloat(subscriptionText.split('+')[1].replace('Save', '').replace('%', '')) || 0;
    const oldPrice = (parseFloat(currentPrice) / (1 - savingsPercentage / 100)).toFixed(0);
    const subscriptionFinalPrice = (parseFloat(currentPrice) * (1 - (discountSettings?.saleDiscount / 100))).toFixed(2);
    const oneTimeFinalPrice = productSettings?.originalPrice / 100;
    const discountedOneTimePrice = oneTimeFinalPrice * (1 - (discountSettings?.saleDiscount / 100));

    const formattedDiscountedOneTimePrice = formatPrice(discountedOneTimePrice)
    const formattedOneTimeFinalPrice = formatPrice(oneTimeFinalPrice)
    const formattedCurrentPrice = formatPrice(currentPrice)
    const formattedSalePrice = formatPrice(productSettings?.salePrice / 100)

    priceElement.innerHTML = `${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) ? `<span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span class="old-price" aria-hidden="true">$${formattedOneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>$${subscriptionFinalPrice}` : `<span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span class="old-price" aria-hidden="true">$${formattedOneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>$${currentPrice}`}`;
    oneTimePriceElement.innerHTML = `One-time purchase <span class="one-time-price">${
      (productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'one' || discountSettings?.saleScope == 'all')) ? 
        `<span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${formattedOneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span><span style="color: #4d6245; margin-right: 6px;">$${formattedDiscountedOneTimePrice}</span>` : 
        `$${formattedOneTimeFinalPrice}`
    }</span>`;

    atcButton.innerHTML = `
      <span>Add to cart</span>
      &nbsp;-&nbsp;
      ${subscriptionFinalPrice != oneTimeFinalPrice ? 
        `${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) 
          ? `<span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${formattedOneTimeFinalPrice}</span>&nbsp;<span class="visually-hidden">Sale price: </span>$${subscriptionFinalPrice}`
          : `<span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${formattedOneTimeFinalPrice}</span>&nbsp;<span class="visually-hidden">Sale price: </span>$${formattedCurrentPrice}`}` 
        : `$${subscriptionFinalPrice}`
      }
      <div class="loading-overlay__spinner hidden">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;

    stickyAtcSale.innerHTML = `
      <span>Add to cart</span>
        &nbsp;-&nbsp;
        <span class="price-item price-item--regular subscription-price">
          ${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) ? ` <span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span class="old-price" style="text-decoration:line-through; color: #666;" aria-hidden="true">$${formattedOneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>$${(subscriptionFinalPrice)}` : `<span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span class="old-price" style="text-decoration:line-through; color: #666;" aria-hidden="true">$${formattedOneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>$${currentPrice}`}
        </span>
        <div class="loading-overlay__spinner hidden">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>`;

    stickyAtcOneTime.innerHTML = `
      <span>Add to cart</span>
        &nbsp;-&nbsp;
        <span class="price-item price-item--regular subscription-price">
          ${productSettings?.inSaleCollection && discountSettings.salePriceEnabled && (discountSettings.saleScope === 'one' || discountSettings.saleScope === 'all') ? 
          `</span> <span class="visually-hidden">Original price: $${formattedOneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${formattedOneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span><span style="color: #ffffff;">$${formattedSalePrice}` : 
          `$${formattedOneTimeFinalPrice}`}
          </span>
        <div class="loading-overlay__spinner hidden">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>`;

    const subscriptionRadioElement = document.querySelector('.subscription-radio');
    if (subscriptionRadioElement) {
      const existingBenefits = document.querySelector('.subscription-widget-benefits');
      if (existingBenefits) {
        existingBenefits.remove();
      }

      subscriptionRadioElement.querySelector('.rc-radio__label')
       .insertAdjacentHTML('afterend', benefitsText);
    }
  } catch (error) {
    console.error('Error in updateOldRechargeWidget:', error);
  }
};

const SELECTORS = {
  widget: '.rc-widget',
  sellingPlansSingle: '.rc-selling-plans-single',
  subscriptionRadio: '.subscription-radio',
  subscriptionText: '.rc-radio__subscription',
  sellingPlans: '.rc-selling-plans',
  radioPrice: '.rc-radio__price',
  oneTimePrice: '.onetime-radio .rc-radio__label',
  addToCartButton: '.product-form__submit',
  stickyAtcSale: '#sticky-atc-subscribe',
  stickyAtcOneTime: '#sticky-atc-onetime',
  stickyAtcDiscount: '.sticky-add-to-cart .auto-replenish-save-text',
  subscriptionBenefits: '.subscription-widget-benefits'
};

const getElement = (selector) => {
  const element = document.querySelector(selector);
  if (!element) {
    throw new Error(`Element not found: ${selector}`);
  }
  return element;
};

const getWidgetId = (widgetElement) => {
  const parentId = widgetElement.parentElement?.id;
  if (!parentId) {
    throw new Error('Widget parent element has no ID');
  }
  return parentId.split('_')[1];
};

const findSellingPlan = (rechargeWidget, planText) => {
  const plan = rechargeWidget.product.plans.find(plan => plan.title === planText);
  if (!plan) {
    throw new Error('Selling plan not found');
  }
  return plan;
};

const findCurrentPlan = (rechargeWidget, sellingPlanId) => {
  const variant = rechargeWidget.product.variants.find(
    variant => variant.prices.some(
      price => price.plans.some(plan => plan.id === sellingPlanId)
    )
  );

  if (!variant) {
    throw new Error('Variant not found');
  }

  const price = variant.prices.find(
    price => price.plans.some(plan => plan.id === sellingPlanId)
  );

  return price.plans.find(plan => plan.id === sellingPlanId);
};

const calculatePrices = (currentPrice, sellingPlansDiscount, currentPlan) => {
  const oldPrice = (parseFloat(currentPrice) / (1 - parseFloat(sellingPlansDiscount) / 100)).toFixed(0);
  let subscriptionFinalPrice = parseFloat(currentPrice);

  if (subscriptionFinalPrice % 1 === 0) {
      subscriptionFinalPrice = subscriptionFinalPrice.toFixed(0);
  } else {
      subscriptionFinalPrice = subscriptionFinalPrice.toFixed(2);
  }

  const oneTimeFinalPrice = window.productSettings?.inSaleCollection && window.productSettings?.showSalePrice 
    ? (parseFloat(currentPlan.discounted_price) + parseFloat(currentPlan.discount_value)) 
    : oldPrice;

  return {
    oldPrice,
    subscriptionFinalPrice,
    oneTimeFinalPrice
  };
};

const updateSubscriptionText = (element, sellingPlansText, sellingPlansDiscount) => {
  // Check if we're in the LP Product Form v3 section
  if (element.closest('.lp-product-form-v3')) {
    // For LP Product Form v3 section, check if there's only one selling plan option
    const frequencySelect = element.closest('.lp-product-form-v3').querySelector('#rc_shipping_interval_frequency');
    const visibleOptions = frequencySelect ? Array.from(frequencySelect.options).filter(option => 
      option.style.display !== 'none' && !option.disabled
    ) : [];
    
    if (visibleOptions.length === 1) {
      // Show frequency text instead of dropdown for single option
      element.innerHTML = visibleOptions[0].textContent.trim();
      
      // Hide the dropdown since we're showing the text
      if (frequencySelect) {
        frequencySelect.style.display = 'none';
        const dropdownContainer = frequencySelect.closest('.options-selector');
        if (dropdownContainer) {
          dropdownContainer.style.display = 'none';
        }
      }
    } else {
      // Multiple options, show as normal
      element.innerHTML = sellingPlansText;
      
      // Ensure dropdown is visible for multiple options
      if (frequencySelect) {
        frequencySelect.style.display = '';
        const dropdownContainer = frequencySelect.closest('.options-selector');
        if (dropdownContainer) {
          dropdownContainer.style.display = '';
        }
      }
    }
  } else {
    // For main product section (PDP), show Subscribe + Save format with combined percentage
    const totalSavingsPDP = getCombinedSavingsPercent(parseFloat(sellingPlansDiscount));
    element.innerHTML = `Subscribe <span class="plus">+</span> <span class="save-percentage">Save ${totalSavingsPDP.toFixed(0)}%</span>`;
  }
};

const updatePriceElements = (prices, elements) => {
  const discountSettings = window.discountSettings;
  const productSettings = window.productSettings;
  const { radioPrice, oneTimePrice, stickyAtcSale, stickyAtcOneTime } = elements;
  const { subscriptionFinalPrice, oneTimeFinalPrice } = prices;
    
  const hasOneTimeDiscount = productSettings?.inSaleCollection && discountSettings.salePriceEnabled && (discountSettings.saleScope === 'one' || discountSettings.saleScope === 'all');
  // always turn oneTimeFinalPrice into a Number first
  const baseOneTime = parseFloat(oneTimeFinalPrice);

  let discountedOneTimePrice = hasOneTimeDiscount
    ? baseOneTime * (1 - parseFloat(discountSettings.saleDiscount) / 100)
    : baseOneTime;
    
  const discountedPrice = subscriptionFinalPrice * (1 - discountSettings?.saleDiscount / 100);
  const formattedSubscriptionDiscountedPrice = discountedPrice % 1 === 0 
    ? `$${discountedPrice.toFixed(0)}`  
    : `$${discountedPrice.toFixed(2)}`;

  const formattedOneTimeDiscountedPrice = discountedOneTimePrice % 1 === 0 
    ? `$${discountedOneTimePrice.toFixed(0)}`  
    : `$${discountedOneTimePrice.toFixed(2)}`; 

  radioPrice.innerHTML = `${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) ? `<span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span class="old-price" aria-hidden="true">$${oneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>${formattedSubscriptionDiscountedPrice}` : `<span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span class="old-price" aria-hidden="true">$${oneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>$${subscriptionFinalPrice}`}`;
  
  oneTimePrice.innerHTML = `One-time purchase <span class="one-time-price">${
    hasOneTimeDiscount ? 
      `<span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${oneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span><span style="color: #4d6245; margin-right: 6px;">${formattedOneTimeDiscountedPrice}</span>` : 
      `$${oneTimeFinalPrice}`
  }</span>`;
    
  stickyAtcSale.innerHTML = `
    <span>Add to cart</span>
      &nbsp;-&nbsp;
      <span class="price-item price-item--regular subscription-price">
        ${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) ? ` <span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span class="old-price" style="text-decoration:line-through; color: #666;" aria-hidden="true">$${oneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>${formattedSubscriptionDiscountedPrice}` : `<span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span class="old-price" style="text-decoration:line-through; color: #666;" aria-hidden="true">$${oneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span>$${subscriptionFinalPrice}`}
      </span>
      <div class="loading-overlay__spinner hidden">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>`;

  stickyAtcOneTime.innerHTML = `
    <span>Add to cart</span>
      &nbsp;-&nbsp;
      <span class="price-item price-item--regular subscription-price">
        ${hasOneTimeDiscount ? 
        `</span> <span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${oneTimeFinalPrice}</span> <span class="visually-hidden">Sale price: </span><span style="color: #ffffff;">${formattedOneTimeDiscountedPrice}` : 
        `$${oneTimeFinalPrice}`}
        </span>
      <div class="loading-overlay__spinner hidden">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>`;
  
  return { discountedOneTimePrice, hasOneTimeDiscount };
};

const updateAddToCartButton = (button, prices, discountInfo) => {
  const discountSettings = window.discountSettings;
  const { subscriptionFinalPrice, oneTimeFinalPrice } = prices;
  const { discountedOneTimePrice, hasOneTimeDiscount } = discountInfo;
  const productSettings = window.productSettings;
  const discountedPrice = subscriptionFinalPrice * (1 - discountSettings?.saleDiscount / 100);
  const formattedSubscriptionDiscountedPrice = discountedPrice % 1 === 0 
    ? `$${discountedPrice.toFixed(0)}`  
    : `$${discountedPrice.toFixed(2)}`;

  const displayPrice = hasOneTimeDiscount ? discountedOneTimePrice : prices.oneTimeFinalPrice;
  button.innerHTML = `
    <span>Add to cart</span>
    &nbsp;-&nbsp;
    <span class="price-item price-item--regular subscription-price">
      ${subscriptionFinalPrice != oneTimeFinalPrice ? 
        `${(productSettings?.inSaleCollection && discountSettings?.salePriceEnabled && (discountSettings?.saleScope == 'subscription' || discountSettings?.saleScope == 'all')) 
          ? `<span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${oneTimeFinalPrice}</span>&nbsp;<span class="visually-hidden">Sale price: </span>${formattedSubscriptionDiscountedPrice}`
          : `<span class="visually-hidden">Original price: $${oneTimeFinalPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${oneTimeFinalPrice}</span>&nbsp;<span class="visually-hidden">Sale price: </span>$${subscriptionFinalPrice}`}` 
        : `$${subscriptionFinalPrice}`
      }
    </span>
    <div class="loading-overlay__spinner hidden">
      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
  `;
};

const updateSubscriptionBenefits = (subscriptionRadioElement, sellingPlansElement, benefitsText) => {
  const existingBenefits = document.querySelector(SELECTORS.subscriptionBenefits);
  if (existingBenefits) {
    existingBenefits.remove();
  }

  const radioLabel = subscriptionRadioElement.querySelector('.rc-radio__label');
  radioLabel.insertAdjacentHTML('afterend', benefitsText);
      
  subscriptionRadioElement.appendChild(sellingPlansElement);
};

const updateNewRechargeWidget = () => {
  try {
    const widgetElement = document.querySelector(SELECTORS.widget);
    if (!widgetElement) {
      // Stay.ai migration complete 2026-04-27 — ReCharge widget no longer
      // renders, so .rc-widget is absent on PDPs. Silent return; was logging
      // "Recharge widget not found" on every PDP load + every variant change +
      // every URL change tick. See hotfix/dedupe-rebuy-script.
      return;
    }

    let planText = document.querySelector(SELECTORS.sellingPlansSingle)?.textContent;
    
    // If no single plan display, try dropdown
    if (!planText) {
      const dropdownSelect = document.querySelector('.rc-selling-plans-dropdown__select');
      if (dropdownSelect && dropdownSelect.options && dropdownSelect.selectedIndex >= 0) {
        planText = dropdownSelect.options[dropdownSelect.selectedIndex]?.textContent;
      }
    }
    
    
    if (!planText) {
      return;
    }

    const widgetId = getWidgetId(widgetElement);
    const rechargeWidget = window.Recharge?.widgets[widgetId];
    
    if (!rechargeWidget) {
      throw new Error('Recharge widget not initialized');
    }

    const sellingPlan = findSellingPlan(rechargeWidget, planText);
    const currentPlan = findCurrentPlan(rechargeWidget, sellingPlan.id);

    const subscriptionTextElement = getElement(SELECTORS.subscriptionText);
    const sellingPlansElement = getElement(SELECTORS.sellingPlans);
    updateSubscriptionText(subscriptionTextElement, sellingPlan.title, sellingPlan.discount_amount);
    
    // Keep dropdown visible, hide single plan displays
    const hasDropdown = document.querySelector('.rc-selling-plans-dropdown__select');
    if (hasDropdown) {
      // For dropdown products: keep the dropdown visible by overriding CSS
      sellingPlansElement.style.display = 'block';
      const dropdownElement = sellingPlansElement.querySelector('.rc-selling-plans-dropdown');
      if (dropdownElement) {
        dropdownElement.style.display = 'block';
      }
    } else {
      // For single plan products: hide as normal
      sellingPlansElement.style.display = 'none';
    }

    const prices = calculatePrices(currentPlan.discounted_price, sellingPlan.discount_amount, currentPlan);

    const priceElements = {
      radioPrice: getElement(SELECTORS.radioPrice),
      oneTimePrice: getElement(SELECTORS.oneTimePrice),
      stickyAtcSale: getElement(SELECTORS.stickyAtcSale),
      stickyAtcOneTime: getElement(SELECTORS.stickyAtcOneTime)
    };
    updatePriceElements(prices, priceElements);

    const stickyAtcDiscountPercentage = document.querySelector(SELECTORS.stickyAtcDiscount);
    if (stickyAtcDiscountPercentage && sellingPlan.discount_amount) {
      const totalSavingsSticky = getCombinedSavingsPercent(parseFloat(sellingPlan.discount_amount.replace(/\.00/g, '')));
      stickyAtcDiscountPercentage.textContent = `SAVE ${totalSavingsSticky.toFixed(0)}%`;
    }

    const atcButton = getElement(SELECTORS.addToCartButton);
    const discountInfo = updatePriceElements(prices, priceElements);
    updateAddToCartButton(atcButton, prices, discountInfo);

    const subscriptionRadioElement = document.querySelector(SELECTORS.subscriptionRadio);
    if (subscriptionRadioElement) {
      updateSubscriptionBenefits(subscriptionRadioElement, sellingPlansElement, benefitsText);
    }

  } catch (error) {
    console.error('Error updating Recharge widget:', error);
  }
};

let isWidgetInitialized = false;

function initSubscriptionWidgetObserver() {
  if (isWidgetInitialized) return;

  // hotfix/dedupe-rebuy-script: bail out entirely if the ReCharge widget
  // container isn't on the page. Stay.ai is the active subscription system
  // since 2026-04-27, so .recharge-subscription-widget never renders. Without
  // this guard we install a 500ms-interval URL poller, a popstate/hashchange
  // listener, and a global input-change listener that all call into a no-op
  // updateNewRechargeWidget on every PDP for the lifetime of the page.
  if (!document.querySelector('.recharge-subscription-widget, .rc-widget')) {
    isWidgetInitialized = true;
    return;
  }

  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector('.rc-selling-plans-single')) {
      updateNewRechargeWidget();
    } else {
      updateOldRechargeWidget();
    }
    isWidgetInitialized = true;
    observer.disconnect();
  });

  const rechargeWidget = document.querySelector('.recharge-subscription-widget');
  if (rechargeWidget) {
    observer.observe(rechargeWidget, {
      childList: true,
      subtree: true,
    });

    const observer2 = new MutationObserver(() => {
      updateNewRechargeWidget();
    });

    setTimeout(() => {
      const sellingPlansElement = document.querySelector('.rc-widget .rc-selling-plans');
      if (sellingPlansElement) {
        const parentEl = sellingPlansElement.parentElement;
        const subscriptionRadioSibling = parentEl.querySelector('.subscription-radio');

        if (subscriptionRadioSibling) {
          subscriptionRadioSibling.appendChild(sellingPlansElement);
        } else {
          console.error('No sibling with the class ".subscription-radio" was found.');
        }

        observer2.observe(sellingPlansElement, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }, 1000);
  }

  window.addEventListener('popstate', () => {
    updateNewRechargeWidget();
  });

  window.addEventListener('hashchange', () => {
    updateNewRechargeWidget();
  });
  
  // Variant change listener
  document.addEventListener('change', function(e) {
    if (e.target.matches('input[name="id"], select[name="id"], input[data-variant-id]')) {
      // Delay to allow price to update first
      setTimeout(() => {
        updateNewRechargeWidget();
      }, 300);
    }
  });
  
  let currentUrl = window.location.href;
  let urlPollingId = setInterval(() => {
    if (window.location.href !== currentUrl) {
      currentUrl = window.location.href;
      updateNewRechargeWidget();
    }
  }, 500);

  // Pause URL polling when tab is hidden to save resources
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearInterval(urlPollingId);
    } else {
      urlPollingId = setInterval(() => {
        if (window.location.href !== currentUrl) {
          currentUrl = window.location.href;
          updateNewRechargeWidget();
        }
      }, 500);
    }
  });
}

function selectSubscriptionRadio() {
  const subscriptionRadio = document.querySelector('.subscription-radio input[type="radio"]');

  if (subscriptionRadio) {
    if (!subscriptionRadio.checked) {
      subscriptionRadio.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      subscriptionRadio.dispatchEvent(changeEvent);
    }
  } else {
    console.warn('Subscription radio button not found. Please check the selector.');
  }
}

function getVariantFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

function initVariantChangeListener() {
  // hotfix/dedupe-rebuy-script: bail if there's no .subscription-radio on the
  // page. This poller only exists to keep the ReCharge subscription radio in
  // sync with URL variant changes — and .subscription-radio is a ReCharge-
  // specific class that doesn't render under Stay.ai. Without this guard we
  // install a 1000ms-interval URL poller for the lifetime of the page that
  // does nothing but call a no-op selectSubscriptionRadio.
  if (!document.querySelector('.subscription-radio')) {
    return;
  }

  let currentVariant = getVariantFromUrl();
  const pollingInterval = 1000;

  let variantPollingId = setInterval(() => {
    const newVariant = getVariantFromUrl();

    if (newVariant !== currentVariant) {
      currentVariant = newVariant;

      selectSubscriptionRadio();
    }
  }, pollingInterval);

  // Pause variant polling when tab is hidden to save resources
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      clearInterval(variantPollingId);
    } else {
      variantPollingId = setInterval(() => {
        const newVariant = getVariantFromUrl();
        if (newVariant !== currentVariant) {
          currentVariant = newVariant;
          selectSubscriptionRadio();
        }
      }, pollingInterval);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initVariantChangeListener();
});

document.addEventListener('DOMContentLoaded', initSubscriptionWidgetObserver);

const options = document.querySelectorAll('.combined-sku-picker-option input');

options.forEach(option => {
  option.addEventListener('click', (e) => {
    setTimeout(() => {
      updateNewRechargeWidget();
    }, 1);
  });
});

// Also handle shower-duo-variants style variant inputs
const variantOptions = document.querySelectorAll('input[data-variant-id]');

variantOptions.forEach(option => {
  option.addEventListener('click', (e) => {
    setTimeout(() => {
      updateNewRechargeWidget();
    }, 1);
  });
});

// Handle URL variant parameter on page load for data-variant-id inputs
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariantId = urlParams.get('variant');
  
  if (urlVariantId) {
    // Wait a bit for everything to load, then trigger the variant click
    setTimeout(() => {
      const variantInput = document.querySelector('input[data-variant-id="' + urlVariantId + '"]');
      if (variantInput && !variantInput.checked) {
        variantInput.click();
      }
      // Also trigger the Recharge update directly
      setTimeout(() => {
        updateNewRechargeWidget();
      }, 300);
    }, 500);
  }
});

const formatPriceString = (priceText) => {
  const priceMatch = priceText.match(/\$(\d+(?:\.\d{2})?)\s+\$(\d+(?:\.\d{2})?)/);
  
  if (priceMatch) {
    const [_, discountedPrice, originalPrice] = priceMatch;
    return `<span class="visually-hidden">Original price: $${discountedPrice}</span><span style="text-decoration:line-through; color: #666;" aria-hidden="true">$${discountedPrice}</span>&nbsp;<span class="visually-hidden">Sale price: </span>$${originalPrice}`;
  } else {
    return priceText.trim();
  }
};

document.addEventListener('readystatechange', () => {
  if (document.readyState === 'complete') {
    document.querySelectorAll('.rc-radio').forEach(radio => {
      radio.addEventListener('click', () => {
        setTimeout(() => {
          if (radio.classList.contains('rc-radio--active') && radio.classList.contains('onetime-radio')) {
            let price = '';
            if (document.querySelector('.onetime-radio .one-time-price')) {
              const rawPrice = document.querySelector('.onetime-radio .one-time-price').textContent;
              price = formatPriceString(rawPrice);
            } else {
              price = document.querySelector('.onetime-radio .rc-radio__label')
                .textContent
                .replace('One-time purchase', '')
                .trim();
            }
            
            const hasComparePrice = parseFloat(item.CompareAtPrice.replace("$", "")) !== 0;
            const productPriceSpan = hasComparePrice ? `<span class="product-price">${price}</span>` : '';
            document.querySelector('.product-form__submit:not(.sticky-atc)').innerHTML = `
              <span>Add to cart</span>&nbsp;-&nbsp;${price}<span class="price-item price-item--regular subscription-price">${productPriceSpan}</span>
              <div class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>`;
          } else if (radio.classList.contains('rc-radio--active') && radio.classList.contains('subscription-radio')) {
            if (document.querySelector('.rc-selling-plans-single')) {
              updateNewRechargeWidget();
            } else {
              updateOldRechargeWidget();
            }
          }
        }, 1);
      });
    });
  }
});

/* landing page subscription widget */
setTimeout(function () {
  // if ( jQuery("body").hasClass("sg-landing--page") || jQuery("body").hasClass("ads-lp-the-system") ) {
  if (jQuery('body[class*="ads-lp-"]').length) { // checking if this is an ads-landing page which might have the recharge subscription widget 'landing-page-product-form...liquid' section
    // var text =
    //  '<ul class="subscription-widget-benefits"><li>Easy cancellations through the website</li><li>Access to VIP-only sales</li><li>Receive free gifts</li></ul>';
    // jQuery(".rc_label__autodeliver").append(text);
    // var discounted_price = jQuery(".discounted_price").val();
    // var prod_price = jQuery(".prod_price").val();
    // jQuery(".rc_label__autodeliver .rc_label__discount").append(
    //   '<span class="discounted_amount"> - ' +
    //   discounted_price +
    //   ' <span class="product_amout" style="display: none;text-decoration:line-through">(' +
    //   prod_price +
    //   ")</span></span>"
    // );
    // jQuery("#rc_price_onetime").append(
    //   '<span class="product_amout"> - ' + prod_price + "</span>"
    // );
    jQuery(".rc_block__type").click(function () {
      jQuery(".rc_block__type").removeClass("rc_block__type--active");
      jQuery(this).addClass("rc_block__type--active");
    });
    jQuery(".product-form__submit").click(function () {
      var frequency = jQuery("#rc_shipping_interval_frequency")
        .find(":selected")
        .val();
      if (frequency == 30) {
        var selling_plan = jQuery(".rechargefor30").val();
      } else if (frequency == 60) {
        var selling_plan = jQuery(".rechargefor60").val();
      } else if (frequency == 90) {
        var selling_plan = jQuery(".rechargefor90").val();
      } else if (frequency == 180) {
        var selling_plan = jQuery(".rechargefor180").val();
      } 

      const sellingPlanElements = document.getElementsByName("selling_plan");
      if (sellingPlanElements.length > 0) {
        const sellingPlanInput = sellingPlanElements[0].value;
        frequency = sellingPlanInput;
      } else {
        console.error("No element found with the name 'selling_plan'.");
      }
      var variant_id = jQuery(".variant_value").val();
      if (
        jQuery(".rc_block__type__onetime").hasClass("rc_block__type--active")
      ) {
        var data = {
          id: variant_id,
          quantity: 1
        };
      } else {
        var data = {
          id: variant_id,
          quantity: 1,
          selling_plan: frequency
        };
      }
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {},
        error: function(error){
          console.error('cart error', error.responseText);
        }
      });
    });
  }
}, 1000);

// sale price change observer. adds final price to ATC button
const targetElements = document.querySelectorAll('.product-form__submit .price-item');

// Function to handle mutations
  const handleMutation = (mutation, element) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      var priceNum = parseFloat(element.textContent.match(/[\d.]+/)[0]);

      var saleEl = element.parentElement.querySelector('.price-sale');
      if (saleEl) {
        var saleNum = priceNum * (1 - parseFloat(saleEl.getAttribute('data-discount')));
        if (saleNum != priceNum) {
          saleEl.textContent = '$' + saleNum.toFixed(2).replace(/\.00/, '');
        }
      }
      element.textContent = '$' + priceNum.toFixed(2).replace(/\.00/, '');

      document.querySelectorAll('.rc-option__price').forEach((priceElement) => {
        let updatedText = priceElement.textContent.replace(/\.00/g, '');
        priceElement.textContent = updatedText;
      });
    }
  };

  // Configuration for the observer (same for all elements)
  const config = {
    attributes: true,
    attributeFilter: ['class']
  };

  // Attach the observer to each target element
  targetElements.forEach(targetElement => {
    const observer = new MutationObserver((mutationsList, observer) => {
      mutationsList.forEach(mutation => handleMutation(mutation, targetElement));
    });
    observer.observe(targetElement, config);
  });


/* reveal on page scroll elements with .reveal */
document.addEventListener('DOMContentLoaded', () => {
  const items = Array.from(document.querySelectorAll('.reveal'));
  if (!items.length) return; // nothing to do if no .reveal on this page

  // Add stagger per index
  items.forEach((el, i) => {
    el.style.setProperty('--stagger', `${i * 0.15}s`);
  });

  // Fallback: if IntersectionObserver not supported, just show them
  if (!('IntersectionObserver' in window)) {
    items.forEach(el => el.classList.add('in'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.15
  });

  items.forEach(el => io.observe(el));
});